<template>
	<Modal width='600' :mask-closable="false" :footer-hide='true' v-model='value'>
		<div class='content'>
			<div class="title">
				<div class="icon">
					<Icon type="ios-help" color='white' size='30'/>
				</div>
				{{content.title}}
			</div>
			<div v-html='content.content'></div>
		</div>
		<div class='footer'>
			<div v-if='content.cancelText' class='btn' v-html='content.cancelText' @click='content.onCancel'></div>
			<div v-if='content.okText' class='btn' v-html='content.okText' @click='content.onOk'></div>
		</div>
	</Modal>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				content:{
					title:'',
					content:'',
					okText:'',
					cancelText:"",
					onOk:()=>{},
					onCancel:()=>{},
				},
				value:false,
				
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {

		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				
			]),
			async initData(){

			},
			show({content,title,okText,cancelText,onOk,onCancel}){
				this.content ={
					title,
					content,
					okText,
					cancelText,
					onOk,
					onCancel,
				}
				this.value = true
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	.title {
		display:flex;
		align-items: center;
		margin-bottom: 20px;
		font-weight: bold;
		font-size: 18px;
		.icon {
			background-color:#FF9900;
			border-radius: 50%;
			width:30px;
			height:30px;
			align-items: center;
			justify-content:center;
			margin-right: 10px;
		}
	}
	.content {
		padding:20px;
		font-size: 15px;
	}
	.footer {
		display:flex;
		justify-content:flex-end;
		gap: 15px;
		margin-top: 15px;
		padding-right:20px;
	}
	.btn {
		display:flex;
		flex-direction: column;
		align-items:center;
		background-color:$theme-color;
		color:white;
		padding:5px 15px;
		border-radius: 8px;
		line-height: 16px;
		cursor:pointer;
		&:hover {
			background-color:$blue;
		}
	}
</style>